/* import __COLOCATED_TEMPLATE__ from './schedule-sidebar-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();